import { useState } from "react";
import LmsTable from "../ui/LmsTable";
import { useParseRouteActions, useFetchData } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import { GlobalConstants } from "../../constants/GlobalConstants";
import { FeatureFlags } from "../../constants/LocalServerConstants";
import { IdProps } from "../../interfaces/Global";

const LmsNewMenusLoanConditionDefaultTable = ({ setSelectedConditions, setIsEditMultiple }) => {
  const handleEditMultipleClick = (options) => {
      if (options?.getCheckedRowsData) {
        setSelectedConditions(options.getCheckedRowsData());
        setIsEditMultiple(true);
      }
  };

  const editMultipleAction = { text: "Edit Multiple", icon: GlobalConstants.Icons.CARET_UP, handleClick: handleEditMultipleClick, isDisabled: (checkedItems) => checkedItems?.length !== 0 };
  const actionsButtons = ["add", "edit", "remove", "export", "save", "cancel", editMultipleAction];
  return <LmsTable
    actionButtons={actionsButtons}
    apiSuffix="menu/loan-condition-default"
    deleteSuffix="menu/loan-condition-default"
    myForm={addLoanConditionDefaultFields(new BCFormController())}
    saveSuffix="menu/loan-condition-default"
  />;
};

const LmsConditionTypeOption = [
  {
    key: "Underwriting",
    text: "Underwriting",
    value: "Underwriting",
  },
  {
    key: "Closing",
    text: "Closing",
    value: "Closing",
  }
];

const addLoanConditionDefaultFields = (myForm: BCFormController) => {
  myForm.addGroupFields([
    myForm.getDropdownField("Loan Program", "metadata/list-loan-programs", { required: true, inlineEdit: true, tableName: "loanProgram", tableValueName: "loanProgramId" }),
    myForm.getDropdownField("Loan Sub Type", "metadata/list-loan-sub-types", { required: true, inlineEdit: true, tableName: "loanSubType", tableValueName: "loanSubTypeId" }),
    myForm.getDropdownField("Condition Type", LmsConditionTypeOption, { name: "conditionTypeOption", required: true, inlineEdit: true }),
    myForm.getDropdownField("Condition Status", "metadata/list-condition-statuses", { required: true, inlineEdit: true, tableName: "conditionStatus", tableValueName: "conditionStatusId" })
  ]);

  myForm.addGroupFields([
    myForm.getDropdownField("Condition Timing", "metadata/list-condition-timings", { required: true, inlineEdit: true, tableName: "conditionTiming", tableValueName: "conditionTimingId" }),
    myForm.getDropdownField("Loan Condition Phase", "metadata/list-loan-condition-phases", { inlineEdit: true, tableName: "loanConditionPhase", tableValueName: "loanConditionPhaseId" }),
    myForm.getCheckboxField("Escrow Instruction", { name: "escrowInstruction", inlineEdit: true }),
    myForm.getCheckboxField("Is Active", { name: "isActive", value: true, inlineEdit: true })
  ]);

  myForm.addGroupFields([
    myForm.getLabelField("State Option"),
    myForm.getGroupRadioField("All States"),
    myForm.getGroupRadioField("State Specific"),
    myForm.getBlankField(),
    myForm.getBlankField(),
    myForm.getBlankField(),
    myForm.getDropdownField("State(s)", "orgs/list-states", { name: "defaultStateIds", isHidden: { stateOption: "State Specific" }, isHiddenOperation: "notequal", dropdownMultiple: true, width: 4 })
  ], { radioGroupName: "stateOption", widths: 1 });

  myForm.addGroupFields([ 
    myForm.getTextareaField("Description", { inlineEdit: true, width: 16, required: true }),
    myForm.getTextareaField("Reason", { inlineEdit: true, width: 16 }),
    myForm.getTextareaField("External Notes", { inlineEdit: true, width: 16 })
  ]);
    
  return myForm;
};

const AddLoanConditionDefaultForm = () => {
  const myForm = addLoanConditionDefaultFields(new BCFormController({}, { 
    submitSuffix: "menu/loan-condition-default",
    submitMethod: "POST", 

  }));
  return <LmsFormGenerator myForm={myForm}/>;
};

const EditLoanConditionDefaultForm = ({ id }: IdProps) => {
  if (FeatureFlags.IS_DEBUG) {
     console.log(id);
  }

  const [{ data, isLoading, error }] = useFetchData(`menu/loan-condition-default/${id}`);  
  const myForm = addLoanConditionDefaultFields(new BCFormController(data, { 
    submitSuffix: "menu/loan-condition-default",
    submitMethod: "PUT", 
    deleteSuffix: "menu/loan-condition-default",
    clearSuffixesOnSubmit: [`menu/loan-condition-default/${id}`]
  }));
  const formActions = ["save", "save-close", "delete", "close"];
  return <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={formActions}/>;
};

const EditMultipleLoanConditions = ({ selectedConditions }) => {
  const myForm = addLoanConditionDefaultFields(new BCFormController({}, { submitSuffix: "menu/loan-condition-default", skipPlaceHolder: false }));
  const handleSubmit = (inputs, handleSubmit, useFormInstance) => {
    if (FeatureFlags.IS_DEBUG) {
       console.log(inputs, handleSubmit, useFormInstance); // TODO: Handle Submit Call
    }
  };

  const formActions = [{ text: "Submit", icon: GlobalConstants.Icons.SAVE, handleClick: handleSubmit }, "close"];
  return <>
    <LmsTable data={selectedConditions} isDisabled />
    <LmsFormGenerator myForm={myForm} actions={formActions} />
  </>;
};

const LmsNewMenusLoanConditionDefault = ({ params = {}, history }) => {
  const { isMainPage, isAdd, isEdit, isActionAllowed, id } = useParseRouteActions(params);
  const [isEditMultiple, setIsEditMultiple] = useState(false);
  const [selectedConditions, setSelectedConditions] = useState([] as any[]);
  if (!isActionAllowed) {
    history.goBack();
  }

  return (<>
    {(isMainPage && !isEditMultiple) && <LmsNewMenusLoanConditionDefaultTable setSelectedConditions = {setSelectedConditions} setIsEditMultiple = {setIsEditMultiple} />}
    {isAdd && <AddLoanConditionDefaultForm />}
    {isEdit && <EditLoanConditionDefaultForm id={id} />}
    {isEditMultiple && <EditMultipleLoanConditions selectedConditions={selectedConditions} />}
  </>);
};

export default LmsNewMenusLoanConditionDefault;